export const typeContainer = [
  { id: "across", name: "across" },
  { id: "acrossOverlay", name: "acrossOverlay" },
  { id: "vertical", name: "vertical" },
  { id: "verticalOverlay", name: "verticalOverlay" },
  { id: "grid", name: "grid" },
  { id: "gridBar", name: "gridBar" },
]

export const typeImageAnimation = [
  { id: "to", name: "to" },
  { id: "from", name: "from" },
]

export const easeAnimation = [
  { id: "easeInSine", name: "easeInSine" },
  { id: "easeOutSine", name: "easeOutSine" },
  { id: "easeInOutSine", name: "easeInOutSine" },
  { id: "easeInQuad", name: "easeInQuad" },
  { id: "easeOutQuad", name: "easeOutQuad" },
  { id: "easeInOutQuad", name: "easeInOutQuad" },
  { id: "easeInCubic", name: "easeInCubic" },
  { id: "easeOutCubic", name: "easeOutCubic" },
  { id: "easeInOutCubic", name: "easeInOutCubic" },
  { id: "easeInQuart", name: "easeInQuart" },
  { id: "easeOutQuart", name: "easeOutQuart" },
  { id: "easeInOutQuart", name: "easeInOutQuart" },
  { id: "easeInQuint", name: "easeInQuint" },
  { id: "easeOutQuint", name: "easeOutQuint" },
  { id: "easeInOutQuint", name: "easeInOutQuint" },
  { id: "easeInExpo", name: "easeInExpo" },
  { id: "easeOutExpo", name: "easeOutExpo" },
  { id: "easeInOutExpo", name: "easeInOutExpo" },
  { id: "easeInCirc", name: "easeInCirc" },
  { id: "easeOutCirc", name: "easeOutCirc" },
  { id: "easeInOutCirc", name: "easeInOutCirc" },
  { id: "easeInBack", name: "easeInBack" },
  { id: "easeOutBack", name: "easeOutBack" },
  { id: "easeInOutBack", name: "easeInOutBack" },
  { id: "easeInElastic", name: "easeInElastic" },
  { id: "easeOutElastic", name: "easeOutElastic" },
  { id: "easeInOutElastic", name: "easeInOutElastic" },
  { id: "easeInBounce", name: "easeInBounce" },
  { id: "easeOutBounce", name: "easeOutBounce" },
  { id: "easeInOutBounce", name: "easeInOutBounce" },
]

export const typeTexty = [
  { id: "left", name: "left" },
  { id: "right", name: "right" },
  { id: "top", name: "top" },
  { id: "bottom", name: "bottom" },
  { id: "alpha", name: "alpha" },
  { id: "scale", name: "scale" },
  { id: "scaleX", name: "scaleX" },
  { id: "scaleBig", name: "scaleBig" },
  { id: "scaleY", name: "scaleY" },
  { id: "mask-bottom", name: "mask-bottom" },
  { id: "mask-top", name: "mask-top" },
  { id: "flash", name: "flash" },
  { id: "bounce", name: "bounce" },
  { id: "swing", name: "swing" },
  { id: "swing-y", name: "swing-y" },
  { id: "swing-rotate", name: "swing-rotate" },
]

export const modeTexty = [
  { id: "smooth", name: "smooth" },
  { id: "reverse", name: "reverse" },
  { id: "random", name: "random" },
  { id: "sync", name: "sync" },
]
export const textTransform = [
  { id: "uppercase", name: "uppercase" },
  { id: "lowercase", name: "lowercase" },
  { id: "normal", name: "normal" },
  { id: "capitalize", name: "capitalize" },
]

export const fontWeight = [
  { id: "normal", name: "normal" },
  { id: "bold", name: "bold" },
  { id: "100", name: "100" },
  { id: "200", name: "200" },
  { id: "300", name: "300" },
  { id: "400", name: "400" },
  { id: "500", name: "500" },
  { id: "600", name: "600" },
  { id: "700", name: "700" },
  { id: "800", name: "800" },
  { id: "900", name: "900" },
]

export const fontFamily = [
  { id: "Roboto", name: "Roboto" },
  { id: "Rage Italic", name: "Rage Italic" },
  { id: "Montserrat", name: "Montserrat" },
  { id: "Ubuntu", name: "Ubuntu" },
  { id: "sans-serif", name: "sans-serif" },
]

export const defaultItemList = {
  bg: {
    imageUrl: {
      url:
        "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-4TX.png",
      urlMobile: "",
      desktop: {
        width: 0,
        height: 0,
      },
      mobile: {
        width: 0,
        height: 0,
      },
    },
    isBgImage: false,
    backgroundColor: "#650101",
  },
  name: "QueueAnim",
  url_image:
    "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-4TX.png",
  url_image_mobile: "",
  url_bg: "",
  url_bg_mobile: "",
  imageUrl: {
    url:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-4TX.png",
    urlMobile: "",
    desktop: {
      width: 0,
      height: 0,
    },
    mobile: {
      width: 0,
      height: 0,
    },
  },
  image: {
    animation: {
      ease: "easeInQuart",
      type: "from",
      delay: 40,
      opacity: 0,
      duration: 1500,
    },
    isAnimation: true,
  },
  title: {
    ease: "",
    mode: "smooth",
    size: "48pt",
    type: "right",
    align: "center",
    color: "#ed747f",
    delay: 200,
    value: "Forbidden City",
    family: "Rage Italic",
    isEase: false,
    italic: true,
    weight: "normal",
    duration: 1600,
    sizeSmall: "20pt",
    lineHeight: "100%",
    sizeMedium: "30pt",
    isAnimation: true,
    letterSpacing: "0px",
    textTransform: "normal",
  },
  position: {
    boxImage: "486px",
    marginLeftText: "-100px",
    marginLeftImage: "50px",
  },
  subtitle: {
    ease: "easeOutQuart",
    mode: "sync",
    size: "48pt",
    type: "alpha",
    align: "center",
    color: "#FFFFFF",
    delay: 100,
    value: "RED BEEN PASTE",
    family: "Montserrat",
    isEase: true,
    italic: false,
    weight: "normal",
    duration: 800,
    sizeSmall: "20pt",
    lineHeight: "100%",
    sizeMedium: "30pt",
    isAnimation: true,
    letterSpacing: "0px",
    textTransform: "uppercase",
  },
  position_image: "left",
}



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/carouselanimation/utils.js